import { VsfContext } from '~/composables/context';
import { Logger } from '~/helpers/logger';
import { Cart, UpdateCartItemsInput } from '~/modules/GraphQL/types';

import { confirmedMutationCart } from '../cartMutationResult';

export const updateItemQtyCommand = {
  execute: async (context: VsfContext, { currentCart, product, quantity, customQuery, customHeaders = {} }) => {
    Logger.debug('[Magento]: Update product quantity on cart', {
      product,
      quantity,
      currentCart,
    });

    const updateCartParams: UpdateCartItemsInput = {
      cart_id: currentCart.id,
      cart_items: [
        {
          cart_item_uid: product.uid,
          quantity,
        },
      ],
    };

    try {
      const response = await context.$magento.api.updateCartItems(updateCartParams, customQuery, customHeaders);
      const { data } = response || {};

      Logger.debug('[Result]:', { data });

      return confirmedMutationCart(response, 'updateCartItems', currentCart.id) as Cart;
    } catch (error) {
      Logger.error('[updateCartItems Error]:', error);
      throw error;
    }
  },
};
